(function(){
  'use strict';
  function by(root,selector){return root.querySelector(selector);}
  function setText(node,value){if(node&&node.textContent!==value)node.textContent=value;}
  function nlMidnight(year,month,day){
    var utc=Date.UTC(year,month,day);
    var parts;
    try{parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',timeZoneName:'shortOffset'}).formatToParts(new Date(utc));}
    catch(error){return NaN;}
    var zone=parts.find(function(item){return item.type==='timeZoneName';});
    var match=zone&&/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/.exec(zone.value);
    if(!match)return NaN;
    var offset=(Number(match[2])*60+Number(match[3]||0))*(match[1]==='-'?-1:1);
    return utc-offset*60000;
  }
  function nlDateParts(date){
    var parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    var data={};
    parts.forEach(function(item){data[item.type]=item.value;});
    return {year:Number(data.year),month:Number(data.month),day:Number(data.day)};
  }
  function timeValues(ms){
    var seconds=Math.max(0,Math.ceil(ms/1000));
    return [Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60];
  }
  function writeClock(fields,values){
    fields.forEach(function(el,index){
      if(!el)return;
      setText(el,String(values[index]).padStart(2,'0'));
    });
  }
  function init(root){
    if(!root||root.dataset.bbActionInitialized==='1')return;
    root.dataset.bbActionInitialized='1';
    var cards=Array.from(root.querySelectorAll('[data-bb-action-item]'));
    var grid=by(root,'[data-bb-action-grid]');
    var hero=by(root,'[data-bb-action-hero-deadline]');
    var toolbar=by(root,'[data-bb-action-filters]');
    var brandSelect=by(root,'[data-bb-action-brand]');
    var typeSelect=by(root,'[data-bb-action-type]');
    var reset=by(root,'[data-bb-action-reset]');
    var count=by(root,'[data-bb-action-count]');
    var empty=by(root,'[data-bb-action-empty]');
    if(!grid||!toolbar||!brandSelect||!typeSelect||!reset||!count||!empty)return;
    var strings={};
    try{strings=JSON.parse(by(root,'[data-bb-action-i18n]').textContent);}
    catch(error){strings={};}
    function t(key,fallback){return strings[key]||fallback||key;}
    var lang=root.dataset.bbActionLang||'nl-NL';
    var dateFormat=new Intl.DateTimeFormat(lang,{timeZone:'Europe/Amsterdam',day:'numeric',month:'long',year:'numeric'});
    var categoryMap={
      matras:t('type_mattress','Matrassen'),
      boxspring:t('type_boxspring','Boxsprings'),
      bed:t('type_bed','Bedden'),
      topper:t('type_topper','Toppers'),
      bedbodem:t('type_base','Bedbodems'),
      beddengoed:t('type_bedding','Beddengoed'),
      overig:t('type_other','Overig')
    };
    var url=new URL(window.location.href);
    var requestedBrand=(url.searchParams.get('merk')||'').toLowerCase();
    var requestedType=(url.searchParams.get('type')||'').toLowerCase();
    var entries=[];
    cards.forEach(function(card,index){
      var counter=by(card,'[data-bb-action-countdown]');
      var source=counter?(counter.dataset.endDate||'').trim():'';
      var match=/^(\d{4})-(\d{2})-(\d{2})$/.exec(source);
      if(!match)return;
      var y=Number(match[1]),m=Number(match[2])-1,d=Number(match[3]);
      if(new Date(Date.UTC(y,m,d)).toISOString().slice(0,10)!==source)return;
      var end=nlMidnight(y,m,d+1),start=nlMidnight(y,m,d-6);
      if(!Number.isFinite(end)||!Number.isFinite(start))return;
      entries.push({
        card:card,index:index,counter:counter,end:end,start:start,y:y,m:m,d:d,expired:false,urgent:false,
        label:by(card,'[data-bb-action-date-label]'),lastDays:by(card,'[data-bb-action-last-days]'),
        fields:[by(card,'[data-bb-countdown-days]'),by(card,'[data-bb-countdown-hours]'),by(card,'[data-bb-countdown-minutes]'),by(card,'[data-bb-countdown-seconds]')]
      });
    });
    var prioritySignature=null;
    var editorMode=!!(window.Shopify&&window.Shopify.designMode);
    function sortCards(){
      if(root.dataset.urgentFirst!=='true'||editorMode)return;
      var urgent=entries.filter(function(e){return !e.expired&&e.urgent;})
        .sort(function(a,b){return a.end-b.end||a.index-b.index;});
      var signature=urgent.map(function(e){return e.index;}).join(',');
      if(signature===prioritySignature)return;
      prioritySignature=signature;
      var pinned=new Set(urgent.map(function(e){return e.card;}));
      var ordered=urgent.map(function(e){return e.card;}).concat(cards.filter(function(c){return !pinned.has(c);}));
      var fragment=document.createDocumentFragment();
      ordered.forEach(function(card){
        card.style.setProperty('--bb-action-order','0');
        fragment.appendChild(card);
      });
      grid.appendChild(fragment);
    }
    function saveFilters(){
      var next=new URL(window.location.href);
      if(brandSelect.value)next.searchParams.set('merk',brandSelect.value);
      else next.searchParams.delete('merk');
      if(typeSelect.value)next.searchParams.set('type',typeSelect.value);
      else next.searchParams.delete('type');
      if(next.href!==window.location.href)window.history.replaceState(window.history.state,'',next.toString());
    }
    function fill(select,options,current){
      select.length=1;
      Array.from(options).sort(function(a,b){return a[1].localeCompare(b[1],lang);}).forEach(function(entry){
        var option=document.createElement('option');
        option.value=entry[0];option.textContent=entry[1];select.appendChild(option);
      });
      select.value=options.has(current)?current:'';
    }
    function refreshOptions(){
      var previousBrand=brandSelect.value||requestedBrand;
      var previousType=typeSelect.value||requestedType;
      var brands=new Map(),types=new Map();
      cards.forEach(function(card){
        if(card.dataset.bbActionExpired==='1')return;
        var brand=card.dataset.brand||'';
        var type=card.dataset.type||'overig';
        if(brand&&!brands.has(brand))brands.set(brand,card.dataset.brandLabel||brand);
        if(type&&!types.has(type))types.set(type,categoryMap[type]||type);
      });
      fill(brandSelect,brands,brandSelect.value||requestedBrand);
      fill(typeSelect,types,typeSelect.value||requestedType);
      requestedBrand='';requestedType='';
      if((previousBrand&&!brandSelect.value)||(previousType&&!typeSelect.value))saveFilters();
    }
    function updateHero(visible,now){
      if(!hero)return;
      var selected=entries.filter(function(e){return !e.expired&&visible.has(e.card);})
        .sort(function(a,b){return a.end-b.end;})[0];
      hero.hidden=!selected;
      if(!selected)return;
      var title=by(selected.card,'.bb-action-hub__card-title');
      var name=title?title.textContent.trim():'';
      var brand=selected.card.dataset.brandLabel||'';
      if(brand&&name.toLowerCase().indexOf(brand.toLowerCase())===-1)name=brand+': '+name;
      setText(by(hero,'[data-bb-action-hero-name]'),name);
      setText(by(hero,'[data-bb-action-hero-date]'),t('hero_date_prefix','Geldig t/m')+' '+dateFormat.format(new Date(selected.end-1000)));
      var left=selected.end-now;
      var mode=left>604800000?'days':left>86400000?'minutes':'seconds';
      hero.dataset.bbTimeMode=mode;
      hero.classList.toggle('bb-action-hub__hero-deadline--urgent',selected.urgent);
      var nums=timeValues(left);
      if(mode==='days')nums[0]=Math.ceil(left/86400000);
      writeClock([by(hero,'[data-bb-hero-days]'),by(hero,'[data-bb-hero-hours]'),by(hero,'[data-bb-hero-minutes]'),by(hero,'[data-bb-hero-seconds]')],nums);
    }
    function applyFilters(updateUrl,now){
      var brand=brandSelect.value,type=typeSelect.value,visible=new Set();
      cards.forEach(function(card){
        var show=card.dataset.bbActionExpired!=='1'&&(!brand||card.dataset.brand===brand)&&(!type||card.dataset.type===type);
        card.hidden=!show;
        if(show)visible.add(card);
      });
      setText(count,visible.size===1?t('count_single','1 actie'):visible.size+' '+t('count_plural','acties'));
      empty.hidden=visible.size>0;
      if(visible.size===0&&(brand||type)){
        setText(by(empty,'h2'),t('no_results','Geen acties voor deze selectie'));
        setText(by(empty,'p'),t('no_results_help','Kies een ander merk of een andere categorie om meer aanbiedingen te zien.'));
      }
      reset.hidden=!brand&&!type;
      updateHero(visible,now);
      if(updateUrl)saveFilters();
    }
    function tick(){
      if(!root.isConnected)return;
      var now=Date.now(),today=nlDateParts(new Date(now));
      var todayOrdinal=Date.UTC(today.year,today.month-1,today.day);
      var datesChanged=false;
      entries.forEach(function(e){
        var left=e.end-now;
        var expired=left<=0;
        var urgent=!expired&&now>=e.start;
        if(expired!==e.expired){
          e.expired=expired;
          e.card.dataset.bbActionExpired=expired?'1':'0';
          datesChanged=true;
        }
        e.urgent=urgent;
        e.card.dataset.bbActionUrgent=urgent?'1':'0';
        if(e.lastDays)e.lastDays.hidden=!urgent;
        if(e.counter){
          e.counter.hidden=!urgent;
          e.counter.dataset.bbTimeMode=left>86400000?'minutes':'seconds';
          if(urgent)writeClock(e.fields,timeValues(left));
        }
        if(!expired&&e.label){
          var days=Math.round((Date.UTC(e.y,e.m,e.d)-todayOrdinal)/86400000);
          var fullDate=dateFormat.format(new Date(e.end-1000)).replace(/ \d{4}$/,'');
          var label=urgent?(days<=0?t('today_only','Alleen vandaag nog'):days===1?t('tomorrow_last','Morgen de laatste dag'):t('remaining_prefix','Nog')+' '+days+' '+t('remaining_suffix','dagen')):t('until_prefix','Nog t/m')+' '+fullDate;
          setText(e.label,label);
          e.label.classList.toggle('bb-action-hub__date-pill--urgent',urgent);
        }
      });
      sortCards();
      if(datesChanged)refreshOptions();
      applyFilters(false,now);
      var active=entries.filter(function(e){return !e.expired;});
      if(active.length){
        var soonest=active.reduce(function(a,b){return a.end<b.end?a:b;});
        var left=soonest.end-now;
        var delay=left<=86400000?1000:left<=604800000?60000:3600000;
        window.setTimeout(tick,delay);
      }
    }
    brandSelect.addEventListener('change',function(){applyFilters(true,Date.now());});
    typeSelect.addEventListener('change',function(){applyFilters(true,Date.now());});
    reset.addEventListener('click',function(){
      brandSelect.value='';typeSelect.value='';
      applyFilters(true,Date.now());
      brandSelect.focus();
    });
    refreshOptions();
    toolbar.hidden=false;
    tick();
  }
  function boot(){document.querySelectorAll('[data-bb-action-hub]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();